import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/components/ThemeProvider";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      data-testid="theme-toggle"
      className={`relative inline-flex items-center justify-center w-9 h-9 rounded-sm border border-zinc-200 bg-white text-zinc-700 hover:text-[#002FA7] dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300 dark:hover:text-white transition-colors ${className}`}
    >
      <Sun size={15} className={isDark ? "opacity-0 absolute" : "opacity-100"} />
      <Moon size={15} className={isDark ? "opacity-100" : "opacity-0 absolute"} />
    </button>
  );
}
